'use strict';

/**
 * @file
 * Theme JavaScript file.
 */

/* eslint-disable func-names, no-unused-vars, no-mutable-exports */

(function ($, Drupal) {
  Drupal.behaviors.clickableTag = {
    attach: function attach(context, settings) {
      var featuredHorizontal = $('.featured-stories--horizontal');
      featuredHorizontal.hover(function () {
        $(this).toggleClass('hovering');
      });
      featuredHorizontal.click(function (e) {
        window.location = $(this).find('.featured-stories__headline a').attr('href');
        e.preventDefault();
      });

      // Accessibility
      featuredHorizontal.attr('tabindex', 0).attr('role', 'button');
      featuredHorizontal.keypress(function (e) {
        // Spacebar or enter key:
        if (e.keyCode === 32 || e.keyCode === 13) {
          window.location = $(this).find('.featured-stories__headline a').attr('href');
          e.preventDefault();
        }
      });
    }
  };

  // Burger menu toggling.
  Drupal.behaviors.burger = {
    attach: function attach(context, settings) {
      $('.burger').click(function () {
        $(this).toggleClass('is-expanded');
        $('.mm.block-system-menublock').toggleClass('open');
      });
    }
  };

  Drupal.behaviors.mm = {
    attach: function attach(context, settings) {
      $('nav.mm').accessibleMegaMenu({

        /* prefix for generated unique id attributes, which are required
         to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: 'accessible-megamenu',

        /* css class used to define the megamenu styling */
        menuClass: 'nav-menu',

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: 'nav-item',

        /* css class for a megamenu panel */
        panelClass: 'sub-nav',

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: 'sub-nav-group',

        /* css class for the hover state */
        hoverClass: 'hover',

        /* css class for the focus state */
        focusClass: 'focus',

        /* css class for the open state */
        openClass: 'open'
      });
    }
  };

  Drupal.behaviors.mmMobile = {
    attach: function attach(context, settings) {}
  };

  Drupal.behaviors.jqUiTabs = {
    attach: function attach(context, settings) {
      $('.jq-ui-tabs').tabs();
    }
  };

  Drupal.behaviors.TreaSearch = {
    attach: function attach(context, settings) {
      // Disable Mega Menu search click; @see TREASB-497.
      $('a#mega-search-link').bind('click', function (e) {
        e.preventDefault();
      });
    }
  };

  Drupal.behaviors.mobileSearch = {
    attach: function attach(context, settings) {
      // Replacing menu item Search with the search block on mobile/tablet.
      var search = $('li.mega-search').html();
      if ($('ul.nav-menu.mq--t .search--mobile').length < 1) {
        $('.search-block').clone().prependTo('ul.nav-menu').addClass('search--mobile');
      }
      /* if ($(window).width() < 1025) {
         $('ul.nav-menu li:last-child').replaceWith($('.search-block'));
         $('.search-block').addClass('search--mobile');
         $('div.search-block').prependTo('ul.nav-menu');
         // Add .open class for top level items in mobile view.
         $('a.mm-top').each(function (index) {
           // $(this).addClass('open');
         });
       } */
      /* $(window).resize(function () {
        if ($(window).width() < 1025) {
          $('ul.nav-menu li.mega-search').replaceWith($('.search-block'));
          $('.search-block').addClass('search--mobile');
          //comment out ln 113 to test andriod search fix
          $('div.search-block').prependTo('ul.nav-menu');
          // Add .open class for top level items in mobile view.
          $('a.mm-top').each(function (index) {
            // $(this).addClass('open');
          });
        */
      // } else {
      //  if ($('ul.nav-menu.mq--t li.mega-search').length < 1) {
      //   $('div').remove('.search--mobile');
      //   $('ul.nav-menu.mq--t').append('<li class="nav-item  mega-search">' + search + '</li>');
      //  }
      // }
      // if ($(window).width() > 1024) {
      //   if ($('ul.nav-menu.mq--t li.mega-search').length < 1) {
      //     $('div').remove('.search--mobile');
      //     $('ul.nav-menu.mq--t').append('<li class="nav-item  mega-search">' + search + '</li>');
      //   }
      //  }
      // });
    }
  };

  Drupal.behaviors.externalLinks = {
    attach: function attach(context, settings) {
      // Add dialog div.
      $('body').append('<div id="external-dialog" title="You are now leaving Treasury.gov"></div>');
      // Add .external class to external links.
      $('a:not([href^="' + window.location.host + '"]):not([href^="#"]):not([href^="/"]):not([href^="?"]):not([href*=".gov"]):not([href*=".mil"]):not([href^="service.govdelivery.com"]):not([href^="javascript:;"])').addClass('external');
      // Trigger dialog for external links.
      $('a.external').bind('click', function (e) {
        e.preventDefault();
        // add this dummy comment to test checking!!
        var url = this.href; // $(this).attr('href');
        if (!url || url === '') {
          return;
        }
        // Show only the domain in the dialog box.
        var domain = url.replace('http://', '').replace('https://', '').split(/[/?#]/)[0].toLowerCase();
        if (/\.gov$/.test(domain) || /\.mil$/.test(domain)) {
          window.location = url;
          return;
        }
        $('#external-dialog').dialog({
          resizable: false,
          height: 'auto',
          width: 380,
          modal: true,
          draggable: false,
          closeOnEscape: true,
          buttons: [{
            text: 'Click here to access ' + domain,
            click: function click() {
              window.location = url;
            }
          }]
        });
        // Add the text after the button.
        if ($('#external-after').length === 0) {
          $('.ui-dialog-buttonset').after('<div id="external-after">Please check the Privacy Policy of the site you are visiting.</div>');
        }
      });
    }
  };
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var navi = $('#header, #usa-header, #navigation');
    if (scroll >= 400) {
      navi.addClass('scrolled');
    } else {
      navi.removeClass('scrolled');
    }
  });
  // Added by Jon - To offset position of content for fixed header.
  var hero = $('#hero-inner');
  var content = $('#pre-content');
  var logoName = $('.logo img').attr('src');

  function setHeaderMargin() {
    var headerHeight = $('#header').height();
    var navHeight = $('#navigation').height();
    var pushHeight = headerHeight + navHeight;
    if (hero.length > 0) {
      headerHeight = pushHeight - 3;
      $(hero).css('marginTop', pushHeight + 'px');
    } else {
      $(content).css('marginTop', pushHeight + 'px');
    }
  }
  function logoResize() {
    var screenSize = $(window).width();
    var l = logoName.split('.');
    var name = l[0];
    var type = l[1];
    var filename = name + '.old.' + type;
    if (screenSize < 768 && filename.indexOf('old.old') < 1) {
      $('.logo img').attr('src', filename);
    } else if (screenSize > 767) {
      $('.logo img').attr('src', logoName);
    }
  }

  // Set header margin on window resize
  var resizeTimer = void 0;
  $(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      setHeaderMargin();
      logoResize();
    }, 250);
  });
  setHeaderMargin();
  logoResize();
  // Replace Twitter Profile Images with higher res
  setTimeout(function () {
    $('.social-post .profile-pic img').each(function () {
      $(this).attr('src', function (index, attr) {
        return attr.replace('_normal.', '_400x400.');
      });
    });
  }, 1000);

  // Mobile navigation slide in sub nav on menu item touch/click
  if ($(window).width() <= 1024) {
    var target = $('#navigation').find('li.nav-item a.mm-top');
    $(target).on('click touch', function () {
      $(this).next('.sub-nav').addClass('open');
      $('.mobile-sub-nav').on('click touch', function () {
        $('.sub-nav').removeClass('open');
      });
    });
  }

  function resetBoxHeight() {
    var $verticalHeight = 0;
    var horizontalStories = $('.view-featured-stories .view-content .featured-stories--horizontal');
    horizontalStories.each(function () {}).css('height', 'auto');
    horizontalStories.each(function () {
      if ($verticalHeight < $(this).height() && !$(this).hasClass('full-featured-stories--horizontal')) {
        $verticalHeight = $(this).height();
      }
    }).css('height', $verticalHeight);
    $('.full-featured-stories--horizontal').css('height', 'auto');
  }

  setTimeout(function () {
    resetBoxHeight();
  }, 1000);

  var resetTimer = void 0;

  $(window).on('resize', function (e) {
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () {
      resetBoxHeight();
    }, 800);
  });

  $(window).on('load', function (e) {
    $('iframe').contents().find("head").append($("<style type='text/css'> .global-sidebar { display: none !important; visibility: hidden !important; } .main-header { display: none !important; visibility: hidden !important; } .page-body { margin-right: 0 !important; } </style>"));
  });

  // Accordion Menus
  var PREFIX = 'treas';
  var ACCORDION = '.' + PREFIX + '-accordion, .' + PREFIX + '-accordion-bordered';
  var BUTTON = '.' + PREFIX + '-accordion-button[aria-controls]';
  var EXPANDED = 'aria-expanded';
  var MULTISELECTABLE = 'aria-multiselectable';

  $(BUTTON).on('click', function () {
    var BTNid = $(this).attr('aria-controls');
    var CONT = $('.' + PREFIX + '-accordion-content#' + BTNid).attr('aria-hidden');
    if (CONT === 'true') {
      CONT = $('.' + PREFIX + '-accordion-content#' + BTNid).attr('aria-hidden', 'false');
      $(this).attr('aria-expanded', 'true');
    } else {
      CONT = $('.' + PREFIX + '-accordion-content#' + BTNid).attr('aria-hidden', 'true');
      $(this).attr('aria-expanded', 'false');
    }
  });
})(jQuery, Drupal);